const isDev = process.env.NODE_ENV !== "production";

const logger = {
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  error: (...args) => {
    if (isDev) console.error(...args);
  },
};

export default logger;
